import React, { useState } from "react";
import "./Setnewpw.css";
import banner_img from "../../../images/banner-picture.png";
import login_logo from "../../../images/HOA Owl Logo.svg";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputLabel, Input, InputAdornment, IconButton } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { Button } from "@mui/material";
import chevronleft from "../../../images/chevronleft.svg";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { userResetPasswordApi ,userResetPasswordApi1} from "../../../Services/Login/LoginApi/loginApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function SetpwComponent() {
  const [showNewPassword, setShowNewPassword] = useState();
  const [showConfirmPassword, setShowConfirmPassword] = useState();
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email"); // Get the email from query params

  const validateForm = () => {
    const validationErrors = {};

    if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/.test(
        showNewPassword
      ) &&
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/.test(
        showConfirmPassword
      )
    ) {
      validationErrors.showNewPassword =
        "Password must contain at least 8 characters, including uppercase, lowercase, numerals, and symbols.";
    }
    if (showNewPassword !== showConfirmPassword) {
      validationErrors.showConfirmPassword = "Passwords do not match.";
    }
    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      Object.values(errors).forEach((error) => {
        toast.error(error);
      });
      return;
    }

    try {
      const result = await dispatch(
        userResetPasswordApi1({
          email: email,
          new_password: showNewPassword,
        })
      );
      if (userResetPasswordApi1.fulfilled.match(result)) {
        toast.success("Password Reset Successfully", {
          onClose: () => navigate("/password-success"), // Navigate after the toast closes
        });
      } else {
        toast.error("Password Reset failed ! Try Again");
      }
    } catch (error) {
      console.error("Password Reset fetching error ", error);
    }
  };

  const handleBackClick = () => {
    navigate(-1); // Navigates to the previous page
  };

  return (
    <>
      <section className="login-page-one setpw-page">
        <div className="container-fluid p-0 m-0">
          <div className="row m-0 loginpage">
            <div className="col-md-6">
              <div className="login-right-block logo-left-block mb-0">
                <div className="login-logoimg text-center">
                  <img
                    src={login_logo}
                    alt="login-logo"
                    className="login_logo_img"
                  ></img>
                </div>
                <div className="back-btn set-pw">
                  <a href="javascript:void(0)" onClick={handleBackClick}>
                    <img
                      src={chevronleft}
                      alt="chevron-left"
                      class="left-icon"
                    ></img>
                    Back
                  </a>
                </div>
              </div>
              <div className="banner-contents">
                <div className="banner-image">
                  {/* <img src={banner_img} alt="banner-image"></img> */}
                  <div className="text-overlay">
                  {/* <h5>Welcome Back!</h5>
                  <p>
                    Elevate your business insights with precision. Log in to
                    discover and refine your Ideal Customer Profiles
                    effortlessly.
                  </p> */}
                 <p>Creating customizable solutions for overall wellness</p>
                </div>
                </div>
             
              </div>
            </div>
            <div className="col-md-6 login-cols-block">
              <div className="login-right-block desktop-view">
                <div className="login-logoimg text-center">
                  <img
                    src={login_logo}
                    alt="login-logo"
                    className="login_logo_img"
                  ></img>
                </div>
                <div className="back-btn set-pw">
                  <a href="javascript:void(0)" onClick={handleBackClick}>
                    <img
                      src={chevronleft}
                      alt="chevron-left"
                      class="left-icon"
                    ></img>
                    Back
                  </a>
                </div>
              </div>
              <div className="login-page-area setpw-area">
                <div className="login-information log-in">
                  <h1 className="text-center">Set New Password</h1>
                  <p className="pw-texts text-center mt-2">
                    {/* Your new password must be different to previously used
                    passwords. */}
                  </p>
                  <div className="form-login text-left">
                    {/* <div className="mb-4">
                                            <InputLabel htmlFor="standard-adornment-password">Password <span>*</span></InputLabel>
                                            <Input className='password-input-box'
                                                id="standard-adornment-password" placeholder="Password"
                                                type={showPassword ? 'text' : 'password'}
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label={showPassword ? 'hide the password' : 'display the password'}
                                                            onClick={handleClickShowPassword}
                                                            onMouseDown={handleMouseDownPassword}
                                                            onMouseUp={handleMouseUpPassword}
                                                        >
                                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                            />
                                        </div> */}
                    <div className="mb-4">
                      <InputLabel htmlFor="new-password">
                        New Password <span>*</span>
                      </InputLabel>
                      <Input
                        className="password-input-box"
                        id="new-password"
                        placeholder="New Password"
                        type={showNewPassword ? "text" : "password"}
                        onChange={(event) =>
                          setShowNewPassword(event.target.value)
                        }
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                showNewPassword
                                  ? "hide the password"
                                  : "display the password"
                              }
                              onClick={() =>
                                setShowNewPassword((prev) => !prev)
                              }
                              onMouseDown={(event) => event.preventDefault()}
                            >
                              {showNewPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      <div className="pw-text-bottom">
                        {/* Password should be the combination of{" "} */}
                        <span>
                          {/* Uppercase & Lowercase Letters, Numerals and Symbols */}
                        </span>
                        
                      </div>
                    </div>

                    <div className="mb-4">
                      <InputLabel htmlFor="confirm-password">
                        Confirm Password <span>*</span>
                      </InputLabel>
                      <Input
                        className="password-input-box"
                        id="confirm-password"
                        placeholder="Confirm Password"
                        type={showConfirmPassword ? "text" : "password"}
                        onChange={(event) =>
                          setShowConfirmPassword(event.target.value)
                        }
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                showConfirmPassword
                                  ? "hide the password"
                                  : "display the password"
                              }
                              onClick={() =>
                                setShowConfirmPassword((prev) => !prev)
                              }
                              onMouseDown={(event) => event.preventDefault()}
                            >
                              {showConfirmPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </div>
                    <div className="btn-orange">
                      <Button onClick={handleSubmit}>Change Password</Button>
                    </div>
                    <div className="lower-signup-text text-center">
                      {/* <p>
                        Need Help? <a href="">Click Here</a>
                      </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}

export default SetpwComponent;
